import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SupportMaterial = lazy(() => import('../SupportMaterial'));
const SupportManual = lazy(() => import('../SupportManual'));

const SupportMaterialRoutes: RouteObject[] = [
  {
    path: 'support-material',
    element: <SupportMaterial />,
  },
  {
    path: 'support-material/manual',
    element: <SupportManual />,
  },
];

export default SupportMaterialRoutes;
